var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.5C13.1979 2.5 14 3.35938 14 4.375V18.125C14 19.1797 13.1979 20 12.25 20H1.75C0.765625 20 0 19.1797 0 18.125V4.375C0 3.35938 0.765625 2.5 1.75 2.5H4.66667C4.66667 1.13281 5.6875 0 7 0C8.27604 0 9.33333 1.13281 9.33333 2.5H12.25ZM7 1.5625C6.48958 1.5625 6.125 1.99219 6.125 2.5C6.125 3.04688 6.48958 3.4375 7 3.4375C7.47396 3.4375 7.875 3.04688 7.875 2.5C7.875 1.99219 7.47396 1.5625 7 1.5625ZM11.4115 10.625C11.5573 10.4688 11.5938 10.1562 11.4115 9.96094L10.3906 8.86719C10.2083 8.67188 9.91667 8.67188 9.77083 8.86719L5.90625 12.9688L4.22917 11.1719C4.04688 10.9766 3.75521 10.9766 3.60938 11.1328L2.55208 12.2656C2.40625 12.4219 2.36979 12.7344 2.55208 12.9297L5.57812 16.1719C5.72396 16.3672 6.01562 16.3672 6.19792 16.1719L11.4115 10.625Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportMenuIcon);
export default __webpack_public_path__ + "static/media/report-menu-icon.f26b9d6f27be85dba9f416612a743614.svg";
export { ForwardRef as ReactComponent };